import * as moment from "moment";
import * as React from "react";
import RecommendedArticles from "backpack-ui/dist/components/recommendedArticles";
import { createExcerpt } from "../../utils/createExcerpt";
import { getImgixUrl } from "../../utils/getImgixUrl";
import { truncate } from "../../utils/truncate";
export var RecommendedPosts = function (_a) {
    var posts = _a.posts;
    return (React.createElement("div", null,
        React.createElement(RecommendedArticles, { articles: posts.map(function (post) { return ({
                category: post.categories[0].name,
                categoryHref: "/blog/category/" + post.categories[0].slug,
                href: "/blog/" + moment(post.publicationDate).format("YYYY/MM/DD") + ("/" + post.metadata.slug),
                image: getImgixUrl(post.featuredImage ?
                    post.featuredImage.url + "?auto=format&fit=crop&w=600&h=400&q=72" :
                    "https://lonelyplanetstatic.imgix.net/marketing/global/blog_comingsoon.jpg?fit=crop&w=600&h=400&q=72"),
                paragraph: post.excerpt ? truncate(post.excerpt, 25) : createExcerpt(post.content),
                title: post.title,
            }); }) })));
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/recommendedPosts/index.tsx
// module id = lGsI
// module chunks = 3